module.exports = __webpack_public_path__ + "assets/img/White_Online.4d460686.svg";